module.exports = __webpack_public_path__ + "img/4-6.bd99cda6.png";